<template>
  <div class="export-config">
    <div class="title-panel">
      <a-button @click="back" icon="left">返回</a-button>
      <label style="font-weight: bold;margin-left: 20px">{{type.text}}</label>
      <template v-if="type.data && type.data.id">
        <label style="margin-left: 20px">{{type.data.createName}}</label>
        <label style="margin-left: 20px">{{type.data.createTime}}</label>
      </template>
    </div>
    <div class="type">
      <type1 ref="typeModal" v-if="type.value==='1'" :data="type.data" @back="back"></type1>
      <type2 ref="typeModal" v-if="type.value==='2'" :data="type.data" @back="back"></type2>
      <type3 ref="typeModal" v-if="type.value==='3'" :data="type.data" @back="back"></type3>
      <type4 ref="typeModal" v-if="type.value==='4'" :data="type.data" @back="back"></type4>
      <type5 ref="typeModal" v-if="type.value==='5'" :data="type.data" @back="back"></type5>
      <type6 ref="typeModal" v-if="type.value==='6'" :data="type.data" @back="back"></type6>
      <type7 ref="typeModal" v-if="type.value==='7'" :data="type.data" @back="back"></type7>
      <type8 ref="typeModal" v-if="type.value==='8'" :data="type.data" @back="back"></type8>
      <type9 ref="typeModal" v-if="type.value==='9'" :data="type.data" @back="back"></type9>
      <type10 ref="typeModal" v-if="type.value==='10'" :data="type.data" @back="back"></type10>
      <type11 ref="typeModal" v-if="type.value==='11'" :data="type.data" @back="back"></type11>
       <type16 ref="typeModal" v-if="type.value==='16'" :data="type.data" @back="back"></type16>
      <type4 ref="typeModal" v-if="type.value==='12'" :data="type.data" @back="back" :type="type.value"></type4>
    </div>
  </div>
</template>

<script>
  import Type1 from './ExportConfig/Type1'
  import Type2 from './ExportConfig/Type2'
  import Type3 from './ExportConfig/Type3'
  import Type4 from './ExportConfig/Type4'
  import Type5 from './ExportConfig/Type5'
  import Type6 from './ExportConfig/Type6'
  import Type7 from './ExportConfig/Type7'
  import Type8 from './ExportConfig/Type8'
  import Type9 from './ExportConfig/Type9'
  import Type10 from './ExportConfig/Type10'
  import Type11 from './ExportConfig/Type11'
  import Type16 from './ExportConfig/Type16'
  export default {
    name: 'ExportConfig',
    components: { Type16,Type11, Type10, Type9,Type8,Type7,Type6,Type5, Type4, Type3, Type2, Type1 },
    props:{
      type:{
        type:Object,
        default:()=>{
          return {}
        }
      }
    },
    data(){
      return {

      }
    },
    watch:{
      type(){
        this.loadData()
      }
    },
    mounted(){
      this.loadData()
    },
    methods:{
      loadData(){
        this.$nextTick(()=>{
          if(this.$refs.typeModal){
            this.$refs.typeModal.loadData()
          }
        })
      },
      back(){
        this.$emit('back')
      }
    }
  }
</script>

<style scoped lang="less">
  .export-config{
    .title-panel{
      border: 1px solid rgba(0,0,0,0.1);
      padding: 5px;
      border-radius: 5px;
    }
  }

</style>
<style lang="less">
  .export-config{
    .type{
      .info-row{
        margin-top: 10px;
      }
      .title{
        font-weight: bold;
        font-size: 16px;
        padding-left: 10px;
        border-left: 5px solid @primary-color;

      }
      .group-title{
        font-weight: bold;
      }
      .table-row{
        background-color: #fafafa;
      }
      .one-row{
        margin-bottom: 10px;
      }
      .right-panel{
        position: relative;
        height: calc(100vh - 230px);
        .export-btn{
          position: absolute;
          right: 10px;
          bottom: 10px;
        }
      }
      .left-panel{
        height: calc(100vh - 230px);
        overflow-y: auto;
      }
    }
  }

</style>